import angular from 'angular';

export default angular.module('models.relation', []).name;